module.exports = __webpack_public_path__ + "img/water-meter-search-with-circle.3e5ac5a9.png";